import { render, staticRenderFns } from "./StatusOrdini.vue?vue&type=template&id=ad1cbd32&scoped=true"
import script from "./StatusOrdini.vue?vue&type=script&lang=js"
export * from "./StatusOrdini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1cbd32",
  null
  
)

export default component.exports